var map = {
	"./chemical-risk/ChemicalRiskModule.ts": "f361",
	"./declaration/DeclarationModule.ts": "d694",
	"./medtra-user/MedtraUserModule.ts": "e5bb",
	"./professional-risk/ProfessionalRiskModule.ts": "e3ca"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6757";